import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-922a6926"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field has-addons number-input-stepper" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["disabled", "aria-label"]
const _hoisted_4 = { class: "control number-input-stepper-input" }
const _hoisted_5 = ["value", "min", "inputmode", "placeholder", "aria-label"]
const _hoisted_6 = { class: "control" }
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("button", {
        class: "button number-input-stepper-button number-input-stepper-button-left",
        type: "button",
        disabled: _ctx.currentValue <= _ctx.min,
        "aria-label": _ctx.decrementAriaLabel,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrement && _ctx.decrement(...args)))
      }, " - ", 8, _hoisted_3)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("input", {
        value: _ctx.currentValue,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
        type: "number",
        min: _ctx.min,
        inputmode: _ctx.inputmode,
        class: "input has-text-centered",
        placeholder: _ctx.placeholder,
        "aria-label": _ctx.inputAriaLabel
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createElementVNode("button", {
        class: "button number-input-stepper-button number-input-stepper-button-right",
        type: "button",
        "aria-label": _ctx.incrementAriaLabel,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increment && _ctx.increment(...args)))
      }, " + ", 8, _hoisted_7)
    ])
  ]))
}